<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">

          <a-col :span="12">
            <a-form-item label="用户账号">
              <a-input placeholder="" v-model="queryParam.username"></a-input>
            </a-form-item>
          </a-col>
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :span="11">
             <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a-button @click="handleAddUser" type="primary" icon="plus" style="margin-left: 8px">已有用户</a-button>
            </a-col>
          </span>
          <a-col :span="1" v-if="hiddenHandle">
            <a-button  icon="right" @click="hiddenHandle()"></a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table区域-begin -->
    <div>

      <a-table
        style="height:500px"
        ref="table2"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
           <span slot="action" slot-scope="text, record">
             <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteMy(record.id)">
                  <a>删除</a>
                </a-popconfirm>
        </span>
      </a-table>
    </div>
    <!-- 表单区域 -->
    <Select-User-Modal ref="selectUserModal" @selectFinished="selectOK"></Select-User-Modal>
  </div>
</template>

<script>
  import { deleteAction, postAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SelectUserModal from '../system/modules/SelectUserModal'
  export default {
    name: 'UserList',
    components: { SelectUserModal },
    props:{
      url:{
        type:Object,
        default:()=>{
          return {
            list:'',
            delete:'',
            add:''
          }
        }
      },
      hiddenHandle:{
        type: Function,
        default:null
      }
    },
    mixins:[JeecgListMixin],
    data(){
      return {
        baseQueryParam:{},
        disableMixinCreated:true,
        columns: [{
          title: '用户账号',
          align: 'center',
          dataIndex: 'username',
          width: 120
        },
          {
            title: '用户名称',
            align: 'center',
            width: 100,
            dataIndex: 'realname'
          },
          {
            title: '状态',
            align: 'center',
            width: 80,
            dataIndex: 'status_dictText'
          },

          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center',
            width: 120
          }],
      }
    },
    methods:{
      view(userBaseQueryParam){
        this.baseQueryParam = userBaseQueryParam
        this.loadData(1)
      },
      handleAddUser() {
        this.$refs.selectUserModal.visible = true
      },
      handleDeleteMy (id) {
        const that = this;
        postAction(that.url.delete, {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      selectOK(selectKeys){
        const params = Object.assign({},this.baseQueryParam)
        params.userIds = []
        for (let a = 0; a < selectKeys.length; a++) {
          params.userIds.push(selectKeys[a])
        }
        postAction(this.url.add,params).then(res=>{
          if (res.success) {
            this.loadData()
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>